import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as selectors from './selectors';
import reducer, { initialState } from './reducer';

type IStartedRequest = {
  started: number;
};

interface ICompletedRequest extends IStartedRequest {
  ended: number;
}

export interface IErroredRequest<T> extends ICompletedRequest {
  error: Error;
  response?: T;
  state: 'error';
}

export interface ILoadingRequest extends IStartedRequest {
  state: 'loading';
}

export interface ISuccessfulRequest<T> extends ICompletedRequest {
  response?: T;
  state: 'success';
}

export type Request<T> = IErroredRequest<T> | ILoadingRequest | ISuccessfulRequest<T>;

export default {
  actions,
  actionTypes,
  initialState,
  reducer,
  selectors,
};
